
































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import TimeSheetHours from './TimeSheetHours.vue';
import TimeSheetDetail from './TimeSheetDetail.vue';
import { status } from './timesheetStatus';

@Component({
  name: 'TimeSheetCard',
  components: {
    TimeSheetHours,
    TimeSheetDetail,
  },
})
export default class TimeSheetCard extends Vue {
  @Prop() timeSheet;
  @Prop() tabName;
  $moment: any;
  get getCandidateTimeSheetId() {
    return this.timeSheet.candidateTimeSheetId + '';
  }
  get statusLabel() {
    return (
      (this.tabName === status.REJECTED || this.tabName === status.APPROVED
        ? 'Timesheet '
        : '') + this.tabName
    );
  }
  get canEditTimesheet() {
    return (
      this.timeSheet.status !== status.APPROVED
    );
  }
  getDate(miliseconds) {
    const localTime = vxm.utility.convertUTCToLocalTime(miliseconds);
    return this.$moment(new Date(localTime)).format(
      vxm.jobs.getCompanyDateFormat.toUpperCase(),
    );
  }
  onEditTimesheet(e) {
    e.stopPropagation();
    this.$bvModal.show('timesheet-entry-modal');
    vxm.timesheet.setEditTimeSheetId(this.timeSheet.candidateTimeSheetId);
  }
}
